import { SCREEN_SETTING } from "../constants/screenRouter";
import settingScreenStore from "../store/settingScreen";


// Custom hook để sử dụng và cập nhật cấu hình player
const useSettingScreen = (playerId) => {
    const playerScreen = settingScreenStore((state) => state.playerScreen);
    const gotoScreen = settingScreenStore((state) => state.gotoScreen);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        screen: playerScreen[playerId]??SCREEN_SETTING.NO_OPEN,
        gotoScreen
    };
};

export default useSettingScreen;
